<template lang="pug">
  .modal.modal--sm
    button.modal__close(
    @click="$emit('close')"
    )
      img(src="@/assets/images/icons/icon-close.svg")
    h2.modal__title Заявка №{{modalData.number}}
    p.modal__text {{modalData.text}}
    .modal__button
      button.button.button_paint-error.button_full( @click="$emit('close')")
        .button__text Ок

</template>

<script>
export default {
  name: "operator-modal-info",
  props: ["modalData"],
};
</script>
